import { Component, Input } from '@angular/core';
import { Tooth, ToothCrossGroup } from '@features/client/order-workflow/models/tooth.model';
import { OrderProductApiService } from '@features/client/order-workflow/services/order-product-api.service';
import { finalize, first } from 'rxjs/operators';
import { Order } from '@features/client/order-workflow/models/order.model';
import { ToothCrossService } from '@features/client/order-workflow/services/tooth-cross.service';
import { NgClass } from '@angular/common';
import { Tooltip } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tooth-connection',
  templateUrl: './tooth-connection.component.html',
  imports: [NgClass, Tooltip, TranslatePipe],
})
export class ToothConnectionComponent {
  @Input() public tooth: Tooth;
  @Input() public group: ToothCrossGroup;
  @Input() public toothIndex: number;
  @Input() public readonly: boolean;

  private isLoading: boolean;

  constructor(
    private readonly orderProductApiService: OrderProductApiService,
    private readonly toothCrossService: ToothCrossService,
  ) {}

  public get hasGrayBridge(): boolean {
    return this.group?.teeth[this.toothIndex + 1]?.is_connectable;
  }

  public get hasBlueBridge(): boolean {
    return this.tooth?.has_right_connection && this.group?.teeth[this.toothIndex + 1]?.has_left_connection;
  }

  public get hasOrderProducts(): boolean {
    return this.tooth.crown && this.tooth.crown.orderProducts && this.tooth.crown.orderProducts.length > 0;
  }

  public toggleConnection(event: MouseEvent | any): void {
    if (!this.readonly && this.hasOrderProducts && !this.isLoading) {
      const targetClass = event.target.classList.value;
      const side: string = targetClass.match(/bridge/) ? 'right' : null;

      this.isLoading = true;

      this.orderProductApiService
        .toggleConnection(this.tooth.crown.orderProducts[0].id, side)
        .pipe(
          first(),
          finalize(() => {
            return (this.isLoading = false);
          }),
        )
        .subscribe((order: Order) => {
          return this.toothCrossService.setToothCross(order.toothCross);
        });
    }
  }
}
